<template>
    <label class="e-input has-float-label">
      <input
        v-bind="$attrs"
        :value="value"
        class="e-input__control form-control"
        :type="type"
        :placeholder="getPlaceholder"
        @input="$emit('input', $event.target.value)"
      />
      <span class="e-input__label">{{ label }}</span>
    </label>
</template>

<script>
	export default {
		name: "e-input",
    props: {
      value: [String, Number],
		  label: String,
		  type: String,
      placeholder: String,
      floating: Boolean
    },
    computed: {
      getPlaceholder() {
        if(this.floating && !this.placeholder) {
          return ' ';
        }

        return this.placeholder;
      }
    }
	}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/elements/input/input.vue